if (!customElements.get('set-answer')) {
    class SetAnswer extends HTMLElement {
        constructor(){
            super();
            this.requiredAnswers = this.dataset.requiredAnswers == "true";
        }
        connectedCallback() {
            this.selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};
            this.currentUrl = localStorage.getItem('current_url') || '';

            // Gestisci la selezione delle risposte per radio e checkbox
            this.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
                input.addEventListener('change', (event) => {
                    const selectedOption = event.target;
                    const answerValue = selectedOption?.value || '';  // Assicurarsi che selectedOption esista
                    const filterName = selectedOption?.getAttribute('data-url') || '';  // Assicurarsi che il filtro esista
                    const sectionIndex = this.closest('frame-finder-main').dataset.index;

                    // Selezione radio: salva l'ultimo valore selezionato
                    if (selectedOption.type === 'radio') {
                        if(this.requiredAnswers){
                            localStorage.setItem('last_answer', answerValue);
                        }
                        // Aggiorna le risposte selezionate per il radio button
                        this.updateAnswers(sectionIndex, answerValue, 'radio', filterName);
                    }

                    // Selezione checkbox: aggiorna o rimuovi la risposta selezionata
                    if (selectedOption.type === 'checkbox') {
                        this.updateAnswers(sectionIndex, answerValue, 'checkbox', filterName);
                    }

                    // Pubblica l'evento di aggiornamento della domanda
                    publish(PUB_SUB_EVENTS.answerChanged, { sectionIndex, answerValue });

                    // Aggiorna l'URL con tutte le risposte selezionate
                    this.updateUrl();
                });
            });

            const nextButtons = this.querySelectorAll('.next-button');

            if (nextButtons.length > 0) {
                nextButtons.forEach(nextButton => {
                    nextButton.addEventListener('click', () => {
                        const selectedOptions = this.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
                        if (selectedOptions.length === 0) {
                        
                            return;
                        }

                    const sectionIndex = this.closest('frame-finder-main').dataset.index;

                    // Pubblica evento per passare alla domanda successiva
                    publish(PUB_SUB_EVENTS.showQuestion, { direction: 'next', sectionIndex });
                });
            });
            }

            const prevButton = this.querySelector('.prev-button');
            if (prevButton) {
                prevButton.addEventListener('click', () => {
                    publish(PUB_SUB_EVENTS.showQuestion, { direction: 'prev' });
                });
            }

            this.preselectSavedAnswer();
        }

        preselectSavedAnswer() {
            const sectionIndex = this.closest('frame-finder-main').dataset.index;
            const savedAnswers = this.selectedAnswers[sectionIndex];
            
            if (savedAnswers) {
                // Preseleziona i valori salvati sia per i radio che per i checkbox
                this.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
                    if (savedAnswers.includes(input.value)) {
                        input.checked = true;
                        if (input.type === 'radio' && this.requiredAnswers) {
                            localStorage.setItem('last_answer', input.value);  // Solo per i radio button
                        }
                    }
                });
            }
        }
        updateAnswers(sectionIndex, answerValue, inputType, filterName) {
            let selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};
        
            // Gestione dei checkbox (con risposte multiple)
            if (inputType === 'checkbox') {
                selectedAnswers[sectionIndex] = selectedAnswers[sectionIndex] || [];
                
                // Assicurati che selectedAnswers[sectionIndex] sia un array
                if (!Array.isArray(selectedAnswers[sectionIndex])) {
                    selectedAnswers[sectionIndex] = [selectedAnswers[sectionIndex]];
                }
        
                const valueWithFilter = `${filterName}${answerValue}`;
        
                if (selectedAnswers[sectionIndex].includes(valueWithFilter)) {
                    // Se è deselezionato, rimuovilo dalla lista
                    selectedAnswers[sectionIndex] = selectedAnswers[sectionIndex].filter(val => val !== valueWithFilter);
                } else {
                    // Aggiungi il valore se è selezionato
                    selectedAnswers[sectionIndex].push(valueWithFilter);
                }
        
            } else {
                // Per i radio button, sovrascrivi la risposta (una sola selezione)
                selectedAnswers[sectionIndex] = `${filterName}${answerValue}`;
            }
        
            localStorage.setItem('selected_answers', JSON.stringify(selectedAnswers));
        }
        updateUrl() {
            let currentUrl = '';
            const selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};

            for (const index in selectedAnswers) {
                if (Array.isArray(selectedAnswers[index])) {
                    // Gestisce risposte multiple concatenate per i checkbox
                    selectedAnswers[index].forEach(answer => {
                        currentUrl += `${answer}&`;
                    });
                } else {
                    currentUrl += `${selectedAnswers[index][0]}&`; // Assicura che solo un valore venga preso per i radio button
                }
            }

            currentUrl = currentUrl.slice(0, -1); // Rimuove l'ultimo "&"
            localStorage.setItem('current_url', currentUrl);
        }
    }

    customElements.define('set-answer', SetAnswer);
}